export const OfferDeedStatus = Object.freeze({
  VAGUE: 'VAGUE',
  EXACT: 'EXACT',
  CONFIRMED: 'CONFIRMED',
});

// eslint-disable-next-line @typescript-eslint/no-redeclare
export type OfferDeedStatus = typeof OfferDeedStatus[keyof typeof OfferDeedStatus];
